<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết công việc của SALE</h1>
      <div class="btn-group float-right">
        <button
          @click="approve"
          v-if="
            dataPermission.includes('CNPS_WKCLDR_WKCLDR_APPROVE_REJECT') &&
            item.operationType === ''
          "
          class="f12 font-medium btn btn-outline-primary"
        >
          Duyệt
        </button>
        <button
          @click="reject"
          v-if="
            dataPermission.includes('CNPS_WKCLDR_WKCLDR_APPROVE_REJECT') &&
            item.operationType === ''
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Từ chối
        </button>
        <button
          @click="edit"
          v-if="
            dataPermission.includes('CNPS_WKCLDR_WKCLDR_APPROVE_REJECT') &&
            item.operationType === ''
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          {{ isEdit === true ? 'Lưu' : 'Sửa' }}
        </button>
        <button
          @click="$router.push('/sticker-standee/sale')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin chung</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.merchantName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên sale<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.saleName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên người duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.approveByName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian hoàn thành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.timeFinish | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.approveAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <!-- <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Vùng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.regionName && item.regionName[0] }}
                </p>
              </div>
            </div> -->
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tỉnh/TP<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.city }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span
                    class="badge"
                    :class="[item.operationType ? item.operationType : 'WAITING']"
                  >
                    {{ item.operationType | transformData(Config.statusJob) }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Thông tin ảnh</h1>
            <div>
              <div>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in item.urlImage" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item" />
                      </a>
                      <span v-if="isEdit === true" @click="removeFile(index)"
                        ><i class="bx bx-trash bx-sm"></i
                      ></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StickerStandeeService } from '@/services/sticker-standee.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        isEdit: false,
        Config,
        item: {},
        showLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      try {
        this.showLoading = true
        await this.fetchData()
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const res = await StickerStandeeService.getSale({
            id: this.$route.params.id,
          })
          this.item = res.data
          console.log(res)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async approve() {
        const flag = await this.approveMx('Bạn có chắc chắn muốn duyệt công việc trên')
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await StickerStandeeService.saleApprove({
              id: this.$route.params.id,
            })
            if (res.success === true) {
              await this.fetchData()
              this.showSuccessMx('Duyệt công việc thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
      async reject() {
        const { value: flag, note } = await this.rejectMx()
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await StickerStandeeService.saleReject({
              id: this.$route.params.id,
              note,
            })
            if (res.success === true) {
              await this.fetchData()
              this.showSuccessMx('Từ chối công việc thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
      removeFile(id) {
        if (this.item.urlImage.length > 1) {
          return this.item.urlImage.splice(id, 1)
        }
      },
      async edit() {
        if (this.isEdit === false) {
          this.isEdit = true
        } else {
          try {
            this.showLoading = true
            const res = await StickerStandeeService.saleUpdateImg({
              id: this.$route.params.id,
              urlImages: this.item.urlImage,
            })
            if (res.success === true) {
              await this.fetchData()
              this.isEdit = false
              this.showSuccessMx('Cập nhật công việc thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>
